import { render, staticRenderFns } from "./Document.vue?vue&type=template&id=58e101a8&scoped=true"
import script from "./Document.vue?vue&type=script&lang=ts"
export * from "./Document.vue?vue&type=script&lang=ts"
import style0 from "./Document.vue?vue&type=style&index=0&id=58e101a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e101a8",
  null
  
)

export default component.exports